import {
  initRawSchema,
  RawSchema,
  toMentionContent,
  toParagraphContent,
  toTextContent,
} from '@principle-theorem/editor';
import {
  INotification,
  INotificationContextRenderer,
} from '@principle-theorem/notifications';
import {
  NotificationType,
  ICancelledAppointmentResources,
  isAppointmentResource,
  MentionResourceType,
} from '@principle-theorem/principle-core/interfaces';
import {
  CALENDAR_TIME_FORMAT,
  IReffable,
  toMoment,
} from '@principle-theorem/shared';
import { Event } from '../../event/event';
import { toMention } from '../../mention/mention';

export class PatientCancelledAppointmentContextRenderer
  implements
    INotificationContextRenderer<
      RawSchema,
      NotificationType,
      ICancelledAppointmentResources
    >
{
  canRender(notification: INotification): boolean {
    return (
      notification.type === String(NotificationType.PatientCancelledAppointment)
    );
  }

  isResource(data: unknown): data is ICancelledAppointmentResources {
    return isAppointmentResource<ICancelledAppointmentResources>(data);
  }

  render(
    data: ICancelledAppointmentResources,
    _currentStaffer?: IReffable
  ): RawSchema {
    const event = Event.init(data.appointment.event);
    const startTime: string = toMoment(event.from).calendar(
      undefined,
      CALENDAR_TIME_FORMAT
    );

    const patientMention = toMention(data.patient, MentionResourceType.Patient);
    const appointmentMention = toMention(
      { name: startTime, ref: data.appointment.ref },
      MentionResourceType.Appointment
    );

    return initRawSchema([
      toParagraphContent([
        toMentionContent(patientMention),
        toTextContent(' cancelled appointment at '),
        toMentionContent(appointmentMention),
      ]),
    ]);
  }
}
